$(document).ready(function() {  


  // Redirects

  if (window.location.href.indexOf("/shop-all") != -1){
  var url = window.location.href;
  var utm_url = url.replace('https://www.thefragrancebar.co/collections/shop-all','');
  
  window.location.replace("https://www.thefragrancebar.co/collections/all-products"+utm_url);
}

  if (window.location.href.indexOf("#best_selling") != -1){
    $('.collection_filter_option').each(function(){
      setTimeout(function() { 
     $('.trigger__best-selling').trigger('click');
      }, 100);
    });
  }

  if (window.location.href.indexOf("#men") != -1){
    $('.collection_filter_option').each(function(){
      setTimeout(function() { 
     $('.trigger__men').trigger('click');
      }, 100);
    });
  }
  
  
  $('.select_collection_filter_js').click(function() {

    //     Set visual change
    $('.collection_filter_option').removeClass('active');
    $(this).addClass('active');

    //     Filtering

    var filter_tag = $(this).attr('data_value');
    var product_tag_string;
    filter_tag = filter_tag.charAt(0).toUpperCase() + filter_tag.slice(1);
    console.log(filter_tag);

    $('.collection_product_tag_js').each(function() {
      product_tag_string = $(this).attr('value');
      console.log(product_tag_string);

      if(filter_tag == 'Shop-all'){
        $('.Collection_product_card').show();
        $('.Collection_divided').show();
        $('.Collection_all').hide();
      }

      else {
        $('.Collection_divided').hide();
        $('.Collection_all').show();
        if (product_tag_string.indexOf(filter_tag) != -1 ){
          $(this).parent('.Collection_product_card').show();
        }
        else {
          $(this).parent('.Collection_product_card').hide();
        } 
      }
    });
  });

  $('.collection_sort_option_js').change(function() {

    var selected_value = $(this).val();
    console.log(selected_value);

    if (selected_value == 'default') {
      $('.Collection_Sorting__Default').show();
      $('.Collection_Sorting__Price').hide();
    }

    if (selected_value == 'price-ascending') {
      $('.Collection_Sorting__Default').hide();
      $('.Collection_Sorting__Price').show();
    }

  });

  $('.collection_filter_option_js_mobile').change(function() {
    var filter_tag = $(this).val();
    var product_tag_string;
    filter_tag = filter_tag.charAt(0).toUpperCase() + filter_tag.slice(1);

    $('.collection_product_tag_js').each(function() {
      product_tag_string = $(this).attr('value');
      console.log(product_tag_string);

      if(filter_tag == 'Shop-all'){
        $('.Collection_product_card').show();
        $('.Collection_divided').show();
        $('.Collection_all').hide();
      }

      else {
        $('.Collection_divided').hide();
        $('.Collection_all').show();
        if (product_tag_string.indexOf(filter_tag) != -1 ){
          $(this).parent('.Collection_product_card').show();
        }
        else {
          $(this).parent('.Collection_product_card').hide();
        } 
      }
    });
  });

  // (Optional) Active an item if it has the class "is-active"	
  $(".accordion_product_page > .accordion-item_product_page.is-active").children(".accordion-panel_product_page").slideDown();

  $(".accordion_product_page > .accordion-item_product_page").click(function() {
    // Cancel the siblings
    $(this).siblings(".accordion-item_product_page").removeClass("is-active").children(".accordion-panel_product_page").slideUp();
    // Toggle the item
    $(this).toggleClass("is-active").children(".accordion-panel_product_page").slideToggle("ease-out");
  });

  $('.product-template-redesign-images-whole').slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    prevArrow:"<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0420/3062/9014/files/Icon_ionic-ios-arrow-up.png?v=1658384425'/></button>",
    nextArrow:"<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0420/3062/9014/files/Icon_ionic-ios-arrow-up-1.png?v=1658384425'/></button>",
    responsive: [
      {
        breakpoint: 900,
        settings: {
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 1,
          dots: true
        }
      }
    ]
  });
  
  
  $('.product-page-upsell-buy-both-js').click(function() {
    var main_product_id = $(this).attr('main_product_id');
    var upsell_product_id = $(this).attr('upsell_product_id');
   jQuery.post(window.Shopify.routes.root + 'cart/update.js',
  			"updates["+main_product_id+"]=1&updates["+upsell_product_id+"]=1"
		);
    setTimeout(function() { 
        location.href = '/cart';
    }, 1000);
  });

  setTimeout(function() { 
    $('.product-template-redesign-images-whole').css('opacity', '1');
    $('.slidecarthq').find('header').find('h2').text('Your Cart');
  }, 500);



  // Offer Page

  $('.Offer_about_scents_close').click(function(){
    $('.Offer_about_scents_section').hide();
    $('.Offer_bundle_section').show();
    $([document.documentElement, document.body]).animate({
      scrollTop: $(".Offer_section_title").offset().top-50
  }, 300);
  });

  $('.Offer_product_info_tab.Open_Scents_3').click(function(){
    $('.Offer_about_scents_section.Scents_3').show();
    $('.Offer_bundle_section').hide();
    $([document.documentElement, document.body]).animate({
      scrollTop: $(".Offer_about_scents").offset().top-50
  }, 300);
  });
  $('.Offer_product_info_tab.Open_Scents_6').click(function(){
    $('.Offer_about_scents_section.Scents_6').show();
    $('.Offer_bundle_section').hide();
    $([document.documentElement, document.body]).animate({
      scrollTop: $(".Offer_about_scents").offset().top-50
  }, 300);
  });
  $('.Offer_product_info_tab.Open_Scents_9').click(function(){
    $('.Offer_about_scents_section.Scents_9').show();
    $('.Offer_bundle_section').hide();
    $([document.documentElement, document.body]).animate({
      scrollTop: $(".Offer_about_scents").offset().top-50
  }, 300);
  });

  $('.Scroll_to_offer__js').click(function(){
    $([document.documentElement, document.body]).animate({
      scrollTop: $(".Offer_section_title").offset().top-50
  }, 300);
  });

  // Scents pagination

  $('.Offer_scents_go_to_1').click(function(){
    $('.About_scents_first_page').css('display', 'flex');
    $('.About_scents_second_page').hide();
    $('.About_scents_third_page').hide();
    $('.Offer_scents_go_to_1').addClass('active');
    $('.Offer_scents_go_to_2').removeClass('active');
    $('.Offer_scents_go_to_3').removeClass('active');
  });
  $('.Offer_scents_go_to_2').click(function(){
    $('.About_scents_second_page').css('display', 'flex');
    $('.About_scents_first_page').hide();
    $('.About_scents_third_page').hide();
    $('.Offer_scents_go_to_2').addClass('active');
    $('.Offer_scents_go_to_1').removeClass('active');
    $('.Offer_scents_go_to_3').removeClass('active');
  });
  $('.Offer_scents_go_to_3').click(function(){
    $('.About_scents_third_page').css('display', 'flex');
    $('.About_scents_second_page').hide();
    $('.About_scents_first_page').hide();
    $('.Offer_scents_go_to_3').addClass('active');
    $('.Offer_scents_go_to_2').removeClass('active');
    $('.Offer_scents_go_to_1').removeClass('active');
  });



  // Go straight to checkout 

  // $('.Offer_product_atc_button').click(function(evt){
  //   evt.preventDefault();
  // });
});